import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Search as SearchIcon, ShoppingBag } from 'lucide-react';
import { brand, waLink, waLinkProps } from '../mock';
import { useCart } from '../context/CartContext';
import { trackWhatsAppClick } from '../lib/analytics';
import WhatsAppIcon from './WhatsAppIcon';
import ThemeToggle from './ThemeToggle';
import SearchOverlay from './SearchOverlay';

const SiteHeader = ({ onOpenProduct }) => {
  const [searchOpen, setSearchOpen] = useState(false);
  const { items } = useCart();
  const navigate = useNavigate();

  return (
    <header className="q-siteheader" data-testid="site-header">
      <div className="q-siteheader__inner">
        <Link to="/" className="q-siteheader__logo" data-testid="site-header-logo">
          <span className="q-siteheader__logo-mark">
            <img src={brand.logoStatic} alt="" />
          </span>
          <span className="q-siteheader__logo-text">{brand.name}</span>
        </Link>
        <Link to="/" className="q-siteheader__home" data-testid="site-header-inicio">
          ← Inicio
        </Link>

        <div className="q-siteheader__actions">
          <button
            type="button"
            className="q-icon-btn"
            onClick={() => setSearchOpen(true)}
            data-testid="search-trigger"
            aria-label="Buscar"
          >
            <SearchIcon size={19} strokeWidth={1.5} />
          </button>

          <button
            type="button"
            className="q-icon-btn q-icon-btn--cart"
            onClick={() => navigate('/carrito')}
            data-testid="cart-trigger"
            aria-label={`Mi carrito, ${items.length} piezas`}
          >
            <ShoppingBag size={19} strokeWidth={1.5} />
            {items.length > 0 && (
              <span className="q-icon-btn__badge" data-testid="cart-badge">{items.length}</span>
            )}
          </button>

          <ThemeToggle />

          <a
            href={waLink('Hola QUINLATE, quiero información sobre sus piezas.')}
            {...waLinkProps}
            className="q-btn q-btn--gold q-btn--sm q-btn--wa q-siteheader__whatsapp"
            data-testid="site-header-whatsapp"
            aria-label="Cotizar por WhatsApp"
            onClick={() => trackWhatsAppClick('site_header')}
          >
            <WhatsAppIcon size={18} />
          </a>
        </div>
      </div>

      <SearchOverlay
        open={searchOpen}
        onClose={() => setSearchOpen(false)}
        onOpenProduct={onOpenProduct}
      />
    </header>
  );
};

export default SiteHeader;
